export default class User {
  constructor(username="", first_names="", last_names="", email="", password="", password1="",user_role="") {
    this.username = username;
    this.first_names = first_names;
    this.last_names = last_names;
    this.email = email;
    this.password = password;
    this.password1= password1;
    this.user_role=user_role;
  }
}
// export default class User {
//   constructor(username, first_names, last_names, email, password) {
//     this.username = username;
//     this.first_names = first_names;
//     this.last_names = last_names;
//     this.email = email;
//     this.password = password;
//   }
// }